import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { IntlContext } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import moment from 'moment';
import metadata from './InvoicesTable.metadata.json5';
import styles from './InvoicesTable.module.scss';
import messages from './InvoicesTable.messages';
import { Header } from '@jutro/legacy/router';



import { CheckboxField } from '@jutro/legacy/components';



const renderFormattedCurrencyField = (item, index) => {
    return (
        <div >
            <CurrencyField
                id={`currency_${index}`}
                value={item}
                readOnly
                hideLabel
            />
        </div>
    );
};


const getFormattedCurrencyDue = (item, index, property) => {
    if((item.invoiceStatus==="due" || item.invoiceStatus==="billed") && item.paidStatus!== 'fullypaid'&& !(item.hasOwnProperty('invoiceId')))
    {
       
        const Amount=(item[property.id].amount).toLocaleString("en-US", {style:"currency", currency:"USD"})
        
        return <span style={{color:"#ed1c24"}}>{Amount}</span>
       
    }
    return (
        <div >
            <CurrencyField
                id={`currency_${index}`}
                value={item[property.id]}
                readOnly
                hideLabel
                className={styles.dueCurrencyContainer}
                        
            />
        </div>
    );
};

const getFormattedCurrency = (item, index, property) => {
    return renderFormattedCurrencyField(item[property.id]);
};

const getCell = (item, index, property) => {

    if (item.paidStatus === 'fullypaid' ) {
        if(item.invoiceStatus!=='carriedforward')
        {
            return (
                <span>Fully Paid</span>
            )
        }
    }
    if(item.paidStatus!=="fullypaid" && (item.invoiceStatus==='due'||item.invoiceStatus==='billed'))
    {
       
        if(item.hasOwnProperty('invoiceId')){
            return (
                <div className={styles.dueInvoiceComment}>
                    {item.invoiceStatus.charAt(0).toUpperCase()+ item.invoiceStatus.slice(1)}
                </div>
            )
        }
        return (
            <div className={styles.dueComment}>
                {item.invoiceStatus.charAt(0).toUpperCase()+ item.invoiceStatus.slice(1)}
            </div>
        )
        
       
        
               
    }
    return(
        <div className={styles.billStatusCss}>
            {item.invoiceStatus}
        </div>

    )   
};

const getInvoice= (item,index,property)=>
{

    return (
        <div>
            {item[property.id]}
        </div>
    )
}

function InvoicesTable(props) {
    const {
        invoiceSummary,
        selectedInvoices,
        onUpdateSelectedInvoices,
        showPaidDate,
        showSelect,
        selectedyear
    } = props;

    const ID=props.id;


    const intl = useContext(IntlContext);

    const getFormattedDate = useCallback((item, index, property) => {
        return moment(item[property.id]).format('MM/DD/YYYY');
       
    }, []);

    const getStatus = (item, index, property) => {
        if (item.paidStatus === 'fullypaid' && item.invoiceStatus!=="carriedforward") {
            return (
                <span>Fully Paid</span>
            );
        }
        return {
            id: `typekey.InvoiceStatus.${item[property.id]}`,
            defaultMessage: item[property.id]
        };
    };


    const getCheckboxDataCell = useCallback(
        (item, index, property) => {
            const value = item[property.id];
            const selectedIds = [...selectedInvoices];
            const isChecked = selectedIds.indexOf(value) > -1;
            return (
                <CheckboxField
                    id={`${property.id}_${index}`}
                    name={`${property.id}_${index}`}
                    value={isChecked}
                    onValueChange={(selected) => {
                        if (selected) {
                            selectedIds.push(value);
                            onUpdateSelectedInvoices(selectedIds);
                        } else {
                            const updated = selectedIds.filter((iter) => iter !== value);
                            onUpdateSelectedInvoices(updated);
                        }
                    }}
                />
            );
        },
        [selectedInvoices, onUpdateSelectedInvoices]
    );
    

    // Filter code

    const getinvoicedata = useCallback(() => {
        
        const invoicearray =  invoiceSummary;
        if(invoicearray !== undefined) {
           
            return invoicearray.filter((invoicedata)=>{
                const newdate = moment(invoicedata.dueDate).toDate();
                const year = moment(newdate).format('YYYY');
                return year=== selectedyear || selectedyear === '';
                // invoicedata.dueDate.getFullYear()===yearSelected||yearSelected===''
            }).map((invoicedata) => {
                return {
                    invoiceNumber: invoicedata.invoiceNumber,
                    invoiceStatus: invoicedata.invoiceStatus,
                    paidStatus:invoicedata.paidStatus,
                    amountDue: invoicedata.amountDue,
                    dueDate: intl.formatDate(intl.formatDate(moment(invoicedata.dueDate).toDate().toUTCString(), { year: 'numeric', month: 'numeric', day: 'numeric' })),
                    eventDate: intl.formatDate(intl.formatDate(moment(invoicedata.eventDate).toDate().toUTCString(), { year: 'numeric', month: 'numeric', day: 'numeric' })),
                    //dueDate: intl.formatDate(new Date(invoicedata.dueDate), { year: 'numeric', month: 'numeric', day: 'numeric' }),
                    //eventDate: intl.formatDate(new Date(invoicedata.eventDate), { year: 'numeric', month: 'numeric', day: 'numeric' }),
                    totalValue: invoicedata.totalValue,
                   
                };
            });
        };

       
    },[intl, invoiceSummary, selectedyear])



    const overrideProps = {
        tablePaymentScheduleDetail: {
            data: ID==='billingInvoicesComponentId'?getinvoicedata():invoiceSummary
        },
        tablePaymentScheduleDetailLastPaymentDate: {
            visible: showPaidDate
        },
        tablePaymentScheduleDetailPay: {
            visible: showSelect
        },
        tablePaymentScheduleDetailInvoiceNumber:{
            sortable:ID==='billingInvoicesComponentId',
            header:ID==='billingInvoicesComponentId'?"Invoice #":"INVOICE #"
        },
        tablePaymentScheduleDetailOutstandingAmount:{
            header:ID==='billingInvoicesComponentId'?"Outstanding":"OUTSTANDING"
        },
        tablePaymentScheduleDetailDueDate:{
            sortable:ID==='billingInvoicesComponentId',
            header:ID==='billingInvoicesComponentId'?"Due Date":"DUE DATE",
        },
        tablePaymentScheduleDetailTotalValue:{
            visible:ID==='billingInvoicesComponentId'
        },
        tablePaymentScheduleDetailBillStatus:{
            header:ID==='billingInvoicesComponentId'?"Bill Status":"BILL STATUS",
        },
        tablePaymentScheduleDetailDateCreated:{
            header:ID==='billingInvoicesComponentId'?"Date Created":"DATE CREATED",
            sortable:ID==='billingInvoicesComponentId',
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getFormattedDate,
            getFormattedCurrency,
            getCell,
            getCheckboxDataCell,
            getFormattedCurrencyDue,
            getStatus,
            getInvoice
        }
    };

    return (
        <div>
            <MetadataContent uiProps={metadata.componentContent} overrideProps={overrideProps} {...resolvers} />

        </div>

    )
    
}

InvoicesTable.propTypes = {
    invoiceSummary: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    selectedInvoices: PropTypes.arrayOf(PropTypes.string),
    onUpdateSelectedInvoices: PropTypes.func,
    showSelect: PropTypes.bool,
    showPaidDate: PropTypes.bool,
    selectedyear:PropTypes.string
};

InvoicesTable.defaultProps = {
    selectedInvoices: [],
    onUpdateSelectedInvoices: undefined,
    showSelect: false,
    showPaidDate: false,
    
};

export default InvoicesTable;
